import React from 'react';
import { DatePicker } from 'antd';
import { dateHourFormat, disable12MonthsDate, rangePresets, rangePresetsFuture } from '../helpers/DateUtils';

const { RangePicker } = DatePicker;

export default function DiRangePicker({
  allowClear,
  onChange,
  onClear,
  outlined,
  hidePreset,
  showFuturePresets,
  hideTime,
  value,
  enableAllDate
}) {
  const handleDisabledDate = (current, { from }) => {
    if (enableAllDate) {
      return false;
    }
    return disable12MonthsDate(current, { from });
  };

  const getPresets = () => {
    if (hidePreset) return false;
    if (showFuturePresets) return rangePresetsFuture;
    return rangePresets;
  };

  return (
    <RangePicker
      variant={outlined ? 'outlined' : undefined}
      presets={getPresets()}
      disabledDate={handleDisabledDate}
      placeholder={['Inizio', 'Fine']}
      className='mobile-w-100'
      format={dateHourFormat}
      showTime={!hideTime}
      onChange={onChange}
      onClear={onClear}
      value={value}
      allowClear={allowClear}
      readOnly
    />
  );
}
